import { Component, SimpleChanges, Input, OnChanges } from '@angular/core';
import { NotifyService } from './notify.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { NotificationsDialog } from './notifications-dialog/notifications-dialog.component';

@Component({
  selector: 'notify',
  templateUrl: './notify.component.html',
  styleUrls: ['./notify.component.scss'],
})
export class NotifyComponent implements OnChanges {
  @Input() trigger: any;
  @Input() notifications: any;

  constructor(
    private _dialog: MatDialog,
    private _notifyService: NotifyService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.trigger) {
      if (changes.notifications) {
        const notifications = changes.notifications.currentValue;
        if (notifications !== null && notifications) {
          if (notifications.allMessages !== null) {
            const array = notifications.allMessages;
            if (array.length > 0) {
              array.forEach((element) => {
                // loop allmessages and add z's in it at the end
                if (!element.msgBegin.includes('Z')) {
                  const str = element.msgBegin;
                  element.msgBegin = str.concat('Z');
                }
              });
            }
          }
          this.notifications = notifications;
        }
      }
    }
  }

  openNotification(message, position): void {
    this.openNotificationsDialog(message, position);
  }

  // adding styles to mat-dialog
  // https://stackoverflow.com/questions/48688614/angular-custom-style-to-mat-dialog
  // https://material.angular.io/guide/customizing-component-styles

  openNotificationsDialog(element, position): void {
    const dialogRef = this._dialog.open(NotificationsDialog, {
      panelClass: 'notifications-back-color',
      width: '600px',
      height: 'auto',
      disableClose: true,
      data: {
        position: position,
        message: element,
        fromHeader: false,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result?.message?.unRead) {
        this._ackNotification(result.message);
      }
    });
  }

  private _ackNotification(message): void {
    this._notifyService.ackMessage(message).subscribe((response) => {
      if (response.status == '200 OK') {
        this.notifications = response.data;
        this._notifyService.updateUnreadMessageCount();
      }
    });
  }

  parseISOString(s): Object {
    const b = s.split(/\D+/);
    return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
  }

  isoFormatDMY(d, lastRunDate): string {
    const date =
      this.pad(this.pad(d.getUTCMonth() + 1) + '/' + d.getUTCDate()) + '/' + d.getUTCFullYear();
    const time = d.toLocaleTimeString(); // get the local time from full string format
    return date + ' ' + time;
  }

  pad(n): string {
    return (n < 10 ? '0' : '') + n;
  }

  padd(n): string {
    return (n < 100 ? '0' : '') + this.pad(n);
  }
}
